/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connect_Your_Bank_Account_To_RInputs */

const en_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your bank account to receive direct payouts from buyers.`)
};

const es_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta tu cuenta bancaria para recibir pagos directos de los compradores.`)
};

const fr_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez votre compte bancaire pour recevoir des paiements directs des acheteurs.`)
};

const de_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde dein Bankkonto, um direkte Auszahlungen von Käufern zu erhalten.`)
};

const ja_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入者からの直接支払いを受け取るために、銀行口座を接続してください。`)
};

const zh_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接您的银行账户以直接接收买家付款。`)
};

const ar_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اربط حسابك المصرفي لتلقي المدفوعات المباشرة من المشترين.`)
};

const id_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan rekening bank Anda untuk menerima pembayaran langsung dari pembeli.`)
};

const it_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collega il tuo conto bancario per ricevere i pagamenti diretti dagli acquirenti.`)
};

const ru_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключите свой банковский счет, чтобы получать прямые выплаты от покупателей.`)
};

const pt_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte sua conta bancária para receber pagamentos diretos de compradores.`)
};

const ko_connect_your_bank_account_to_r = /** @type {(inputs: Connect_Your_Bank_Account_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`은행 계좌를 연결하여 구매자로부터 직접 정산을 받으세요.`)
};

/**
* | output |
* | --- |
* | "Connect your bank account to receive direct payouts from buyers." |
*
* @param {Connect_Your_Bank_Account_To_RInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const connect_your_bank_account_to_r = /** @type {((inputs?: Connect_Your_Bank_Account_To_RInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connect_Your_Bank_Account_To_RInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connect_your_bank_account_to_r(inputs)
	if (locale === "es") return es_connect_your_bank_account_to_r(inputs)
	if (locale === "fr") return fr_connect_your_bank_account_to_r(inputs)
	if (locale === "de") return de_connect_your_bank_account_to_r(inputs)
	if (locale === "ja") return ja_connect_your_bank_account_to_r(inputs)
	if (locale === "zh") return zh_connect_your_bank_account_to_r(inputs)
	if (locale === "ar") return ar_connect_your_bank_account_to_r(inputs)
	if (locale === "id") return id_connect_your_bank_account_to_r(inputs)
	if (locale === "it") return it_connect_your_bank_account_to_r(inputs)
	if (locale === "ru") return ru_connect_your_bank_account_to_r(inputs)
	if (locale === "pt") return pt_connect_your_bank_account_to_r(inputs)
	return ko_connect_your_bank_account_to_r(inputs)
});